import React, { useState } from "react"
import "./../../CompanysForm.css"
import DebtorForm from "./DebtorForm"
import DebtorTable from "./DebtorTable"
import { PaginationGrid } from "../../../../../../components/Common/PaginationGrid"

const DebtorGrid = ({
  data,
  currentPage,
  setCurrentPage,
  showList,
  setShowList,
  totalPages,
  companySelected,
  setCompanySelected,
}) => {
  return (
    <>
      {showList ? (
        <>
          {!!data.length && (
            <>
              <DebtorTable
                dataArray={data}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                setCompanySelected={setCompanySelected}
                setShowList={setShowList}
                totalPages={totalPages}
              />
            </>
          )}
        </>
      ) : (
        <DebtorForm
          companySelected={companySelected}
          setCompanySelected={setCompanySelected}
          showList={showList}
          setShowList={setShowList}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  )
}

export default DebtorGrid
